module.exports = __webpack_public_path__ + "img/icon-1 (5).49f36e7d.png";